export default "__VITE_ASSET__BZVl5aFT__"